import { useLocation } from 'react-router-dom';

import { route } from '../steps/steps';

type UseBasketSectionParams = {
  data: any;
  sectionLocations: string[];
};

const useBasketSection = ({ data, sectionLocations }: UseBasketSectionParams) => {
  const location = useLocation();
  const isOpen = !!sectionLocations.find((sectionLocation) =>
    sectionLocation === route('root')
      ? location.pathname === sectionLocation
      : location.pathname.startsWith(sectionLocation),
  );

  return { isOpen, isVisible: isOpen || !!data, hasData: !!data };
};

export default useBasketSection;
